<template>
  <div class="user-events">
    <div class="user-events__title">
      Events
      <span class="user-events__count">{{ total }}</span>
    </div>
    <el-link
      class="user-events__see-all"
      type="primary"
      @click="showAllEvents"
      v-if="total > 0"
      >See all</el-link
    >

    <div class="user-events__list">
      <router-link
        class="event"
        v-for="event in latestEventsArray"
        :key="event.eventId"
        :to="{
          name: 'EventPage',
          params: {
            link: event.link,
          },
        }"
      >
        <el-avatar :size="50" class="event__avatar">
          <activity-image :activity="event.activityId" :alt="event.name" />
        </el-avatar>
        <div class="event__description">
          <div class="event__title">{{ event.name }}</div>
          <div class="event__description">{{ event.eventType }}</div>
        </div>
      </router-link>
    </div>

    <p v-if="total === 0" class="user-events__dummy">
      No events
    </p>

    <el-dialog v-model="isPopupActive">
      <template #title>
        <div class="user-events__title">
          Events
          <span class="user-events__count">{{ total }}</span>
        </div>
      </template>
      <div class="row">
        <div
          class="col col-xs-12 col-md-6"
          v-for="event in eventsArray"
          :key="event.eventId"
        >
          <router-link
            class="event event--link"
            :to="{
              name: 'EventPage',
              params: {
                link: event.link,
              },
            }"
          >
            <el-avatar :size="50" class="event__avatar">
              <activity-image :activity="event.activityId" :alt="event.name" />
            </el-avatar>
            <div class="event__description">
              <div class="event__title">{{ event.name }}</div>
              <div class="event__description">{{ event.eventType }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getLatestUserEvents,
  getCurrentUserLatestEvents,
  getCurrentUserAllEvents,
  getUserAllEvents,
} from '@/api/profile.js';
import ActivityImage from '@/components/common/ActivityImage.vue';

export default {
  components: { ActivityImage },
  name: 'Events',
  props: {
    isCurrentUser: {
      type: Boolean,
      required: false,
    },
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      eventsArray: [],
      latestEventsArray: [],
      total: null,
      isPopupActive: false,
    };
  },
  methods: {
    async fetchLatestUserEvents() {
      const { userId } = this;
      const { data, success } = await getLatestUserEvents({ userId });
      if (success) {
        this.latestEventsArray = data.events;
        this.total = data.count;
      }
    },
    async fetchUserAllEvents() {
      const { userId } = this;
      const { data, success } = await getUserAllEvents({ userId });
      if (success) {
        this.eventsArray = data.items;
      }
    },
    async fetchCurrentUserLatestEvents() {
      const { data, success } = await getCurrentUserLatestEvents();
      if (success) {
        this.latestEventsArray = data.events;
        this.total = data.count;
      }
    },
    async fetchCurrentUserAllEvents() {
      const { data, success } = await getCurrentUserAllEvents();
      if (success) {
        this.eventsArray = data.items;
      }
    },

    handleUserEvents() {
      if (this.isCurrentUser) {
        this.fetchCurrentUserLatestEvents();
        this.fetchCurrentUserAllEvents();
      } else {
        this.fetchLatestUserEvents();
        this.fetchUserAllEvents();
      }
    },
    showAllEvents() {
      this.isPopupActive = true;
    },
  },
  created() {
    this.handleUserEvents();
  },
  watch: {
    isCurrentUser(newVal) {
      this.handleUserEvents();
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/shared/_globals.scss';

.user-events {
  position: relative;
  padding: 20px 25px;
  border-radius: var(--border-radius-base);
  background-color: var(--color-gray-50);

  &__dummy {
    margin: var(--global-dimension-size-175) 0 0;
    line-height: 1.6;
  }

  &__title {
    font-weight: 500;
    font-size: var(--font-size-300);
    line-height: 1.6;
  }

  &__count {
    font-weight: normal;
    font-size: var(--font-size-200);
    color: var(--color-gray-700);
    margin-left: var(--global-dimension-size-200);
  }

  &__see-all {
    position: absolute;
    right: 25px;
    top: 20px;
  }

  &__list {
    display: flex;
    flex-flow: column nowrap;
  }
}

.event {
  display: flex;
  margin-top: var(--global-dimension-size-200);

  &--link {
    margin-top: 0;
    margin-bottom: var(--global-dimension-size-300);
    color: var(--color-gray-900);

    &:hover {
      color: var(--color-primary-400);
    }
  }

  &__avatar {
    margin-right: var(--global-dimension-size-125);
  }

  &__description {
  }

  &__title {
    margin-bottom: var(--global-dimension-size-75);
    font-weight: normal;
    font-size: var(--font-size-200);
    line-height: 1.6;
    color: var(--color-gray-900);
  }

  &__description {
    font-size: var(--font-size-150);
    line-height: 1.6;
    color: var(--color-gray-800);
  }
}
</style>
